import {useNavigate} from "react-router-dom";
import {useUsername} from "../../../utils/utils";
import ApplicationCard from "../../ApplicationCard/ApplicationCard";
import {PktButton} from "@oslokommune/punkt-react";
import {AVSLUTT_PRIS_SØKNAD_ROUTE} from "../../../routes";
import React from "react";

export default function ResøknadslistenMenIngenSøknad() {
    const navigate = useNavigate()
    const userName = useUsername()
    return (
        <ApplicationCard title={userName ?? ""} variant={"gul"}>
            <div
                className={"pkt-txt-16-light"}>Vi søker automatisk om redusert barnehagepris for familien din for neste barnehageår.
                Du får en bekreftelse når vi sender søknaden til behandling.
            </div>
            <p
                className={"pkt-txt-16-light"}>Har dere ikke lenger behov for redusert pris, kan du stoppe de
                automatiske søknadene.</p>

            <PktButton onClick={() => navigate(AVSLUTT_PRIS_SØKNAD_ROUTE)} size={"small"}
                       className={"mt-size-16"}>
                Stopp automatiske søknader
            </PktButton>
        </ApplicationCard>
    )
}


